<template>
    <div id="user_settings_page" class="centered" v-if="loaded">
        <div id="top">
            <h2>הגדרות לינקיפדיה</h2>
            <div class="user_name">{{form.display_name}}</div>
            <!-- <Cropper :circle="true" inpName="pic" token="UTBWeVNuUXhXWFZ6V0c1SFNYRjVlR3h5Ym01bk5qQkZXV2RIVURCcU1rdDVRMlJSTVVOblduUXJNSHBEV0ZsR1QwTjRkRFp1YzBWWVIyaHVVSHB1TWtOdmVHTmxXbUZhVkdod1dXRnVNeXN2WVV4TmJXcGxkblF6Ymt0bGJsSndiREowUWxaRU1ISjBUWFpFTms1elpURkdVWEF3ZFZoMVRHbDVkbE12Y1ZsNWVIQlBOR0ZzUTJOT2IxZG1WbkZYUVhoRVVuRTJXbEJPWjNkSE1XMVBkR0pZZGtRNWRtdDNNWEJqUFE9PQ" :sid="$store.user.artists[0].pic" :ratios="[{name:'wide',ratio:1/1,label:'ראשי'}]" /> -->

            <Gallery v-model="form.pic" :token="pic_token" :max="1" />


            <!-- <div class="user_pic" :style="'background-image:url('+ $store.user.artists[0].pic_tumb_big +')'" @click="editCrops=!editCrops">
                <div class="btn"><i class="fas fa-camera"></i></div>
            </div> -->
        </div>
        <div class="user_settings">
            <div class="lpedia-toggle">
                <div class="lpedia-toggle-row">
                    <md-switch :key="lpediaSwitchKey" v-model="form.has_lpedia" @change="saveLpedia">הצג את הלינקיפדיה שלי</md-switch>
                    <span class="lpedia-badge" :class="{ active: form.has_lpedia }">
                        {{ lpediaSaving ? 'שומר...' : (form.has_lpedia ? 'פעילה' : 'כבויה') }}
                    </span>
                </div>
                <p class="lpedia-desc">
                    {{ form.has_lpedia
                        ? 'העמוד האישי שלך גלוי למבקרים בלינקיפדיה.'
                        : 'העמוד האישי שלך לא יוצג באתר — רק אתה יכול לערוך אותו כאן.' }}
                </p>
                <router-link
                    v-if="form.has_lpedia && form.artist_id"
                    :to="'/Artist/' + form.artist_id"
                    class="lpedia-preview-link"
                >
                    צפייה בעמוד שלי
                </router-link>
            </div>
            <div>
                <div >
                    
                    <label> שם:</label>
                    <md-input v-model="form.name" name="name"></md-input>
                </div>
                <div >
                    <label> ביוגרפיה:</label>
                    <md-input type="textarea" v-model="form.bio"></md-input>
                </div>
                
                 <!-- <div class="col-md-6">
                    
                    <label> סגנון מוזיקלי</label>
                    <md-input v-model="form.genre_ids"></md-input>
                    
                <div class="clr"></div>
                </div> -->
            </div>
            <div >
                <div class="agent contact">
                    <div class="checkboxes">
                    <md-switch v-model="form.has_agent" value="1">האם קיים סוכן?</md-switch>
                    </div>
                    <div class="col-md-12" v-if="form.has_agent">
                        <div class="col-md-6" >
                            
                            <label>שם:</label>
                            <md-input  v-model="form.con2_name"></md-input>
                            
                        </div>
                        <div class="col-md-6">
                            
                            <label>פלאפון</label>
                            <md-input v-model="form.con2_phone1"></md-input>
                            
                        </div>
                    </div>
                    <div class="clr"></div>
                </div>
                <div class="pr contact">
                    <div class="checkboxes">
                        <md-switch v-model="form.has_pr" value="1">האם קיים יחצן?</md-switch>
                    </div>
                    <div class="col-md-12" v-if="form.has_pr">
                    <div class="col-md-6" >
                        
                        <label> שם:</label>
                        <md-input v-model="form.con1_name"></md-input>
                        
                    </div>
                    <div class="col-md-6">
                        
                        <label>פלאפון</label>
                        <md-input v-model="form.con1_phone1"></md-input>
                        
                    </div>
                    </div>
                <div class="clr"></div>
            </div>
             <div class="booking contact">
                    <div class="checkboxes">
                        <md-switch v-model="form.has_booking" value="1">האם קיים בוקינג?</md-switch>
                    </div>
                    <div class="col-md-12" v-if="form.has_booking">
                  <div class="col-md-6" >
                    
                    <label> שם:</label>
                    <md-input v-model="form.con3_name"></md-input>
                    
                </div>
                 <div class="col-md-6">
                    
                    <label>פלאפון</label>
                    <md-input v-model="form.con3_phone1"></md-input>
                    
                </div>
                </div>
                <div class="clr"></div>
            </div>
            </div>
            
            <div>
                <h3>רשתות חברתיות:</h3>
                <div v-for="soci in form.soci" :key="soci.field" class="col-md-4">
                    <md-input v-model="soci.value" :label="soci.title"></md-input>
                </div>
                <div class="clr"></div>
            </div>

            <a class="btn_send" @click="save">שמור</a>

        </div>
    </div>
</template>

<script>
//import Cropper from '../components/cropper.vue';
// import Cropper from '../components/picInput.vue';
import Gallery from '@/components/gallery.vue';


export default {
    components: {Gallery},
  data(){
    return {
        editCrops: false,
        form: [],
        artists: [],
        pic_token: false,
        loaded: false,
        lpediaSaving: false,
        lpediaSwitchKey: 0
    }
  },
  mounted(){
       this.api({ action: 'settings_artist' }, (data) => { 
        this.form = data.data.form;
        this.artists = data.data.artists;
        this.pic_token = data.data.pic_token;

        this.loaded = true;
      } );
  },
  methods:{
      save(){
          
       this.api({ action: 'save_settings_artist', data: this.form }, () => { 
        //this.user_data = data.data
        this.alert('הפרטים נשמרו בהצלחה');
      
      } );
      },
      saveLpedia() {
        if (this.lpediaSaving) return;
        const enabled = this.form.has_lpedia;
        this.lpediaSaving = true;
        this.api({ action: 'save_settings_artist', data: this.form }, () => {
          this.lpediaSaving = false;
        }, () => {
          this.lpediaSaving = false;
          this.form.has_lpedia = !enabled;
          this.lpediaSwitchKey++;
          this.alert('שגיאה בשמירה');
        });
      }

  }  
}
</script>
<style  lang="scss" scooped>
.contact{margin-bottom: 15px;}
#user_settings_page{ display: flex; gap:40px;    
    @media (min-width: 600px) { }
    @media (max-width: 600px) { flex-direction: column; }
    .btn_send{ cursor: pointer;;background: #ff1661;color: #fff;padding: 15px 50px;font-weight: 600;font-size: 22px;border-radius: 45px}
    #top{ position: relative;}
    h2{font-size: 30px;font-weight: 600;margin-bottom: 10px;}
    .user_name{color: #8e8d8d;font-size: 25px;margin-bottom: 20px;}
    .user_pic{    height: 150px; width: 150px; background-repeat: no-repeat; background-size: cover; background-position: center; border-radius: 100%;position: relative;}
    .user_pic .btn{ padding: 0; display: block;z-index: 3;border-radius: 100%;width: 45px;height: 45px;background-image: linear-gradient(135deg, #ff1661 13%, #00b7ff 123%);
        position: absolute;bottom: -2px;left: 0px;color: #fff;line-height: 51px;text-align: center;
        .fa-camera{font-size: 22px;}
    }
    .md-field .md-input{height: 50px;background: #eee !important;border-radius: 5px; padding-right:15px;}
    .md-field .md-input.disabeld{background: #f7f7f7 !important;}
    .md-field.md-theme-default:after{display: none;}
    .md-field.md-theme-default label{left: auto;right: 10px;}
    .md-toggle-password{right: auto;left: 10px;top: 24px;}
    .md-checkbox{margin: 10px 0 0 0 ;}
    .md-radio{margin: 0;}
    .checkboxes{
        &{position:relative;}
        span{position: absolute;right: 0px;font-size: 20px;font-weight: 500;color: #8e8d8d;}
    }
    .lpedia-toggle {
        margin-bottom: 24px;
        padding: 16px 18px;
        background: #f7f7f7;
        border-radius: 12px;
        border: 1px solid #eee;
    }
    .lpedia-toggle-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
    }
    .lpedia-toggle .md-switch { margin: 0; }
    .lpedia-badge {
        font-size: 13px;
        font-weight: 600;
        color: #8e8d8d;
        &.active { color: #ff1661; }
    }
    .lpedia-desc {
        margin: 10px 0 0;
        font-size: 14px;
        color: #8e8d8d;
        line-height: 1.5;
    }
    .lpedia-preview-link {
        display: inline-block;
        margin-top: 10px;
        color: #ff1661;
        font-weight: 600;
        text-decoration: none;
        &:hover { text-decoration: underline; }
    }
}
</style>